import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-105" data-mp="9llb731mq8q5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-106" data-mp="4lyx6rdz8oga">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.6rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.5rem]" data-id="element-107" data-mp="4njqkdok21ck">
          Solve a Full Year of Volleyball Coaching in Just{' '}
          <span className="italic text-brand" data-id="element-108" data-mp="nb6llp1d5fmk">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-109" data-mp="3d21ty23jwspu">
          Join 2,000+ Volleyball coaches who stopped improvising. Walk onto every
          court with everything ready to teach, lead, and dominate.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-xl pb-5 pt-2.5 sm:mt-8" data-id="element-110" data-mp="39cfjqxfz4vsg">
          <img src="https://cdn.magicpatterns.com/uploads/niQVQusYaLCgqbU4LTKBVU/b5410b2e-53a8-4f4e-8b75-0884733541cc.webp" alt="The Volleyball Ready pack shown across six digital volumes from The Discovery to The Strategist, on desktop, tablet and phone, with the five strategic bonuses" className="mx-auto w-[88%] sm:w-full" data-id="element-111" data-mp="359javyg8ke1p" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-112" data-mp="2ljgxn43c1lao">
          <CtaButton data-id="element-113" data-mp="n98bzjimsxls" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-114" data-mp="ic88ngd628yd">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-115" data-mp="dbaoiy8lj4u8" data-mpi={index}>
                <span className="whitespace-nowrap" data-id="element-116" data-mp="1b0drfxkntnvk">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-117" data-mp="15zq35jntfl51">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}